import { ServiceHelper } from "../../Everou/_services/ServiceHelper"
import { PMS_API_URLS } from "../_constants/PMS_API_URLS"

export interface PMSReservationsQueryParams {
    offset?: number;
    page_size?: number;
    uid?: string;
    status?: string;
    date_from?: string;
    date_to?: string;
    reservation_id?: string;
}

export const PMSReservationsService = {
    list,
    setEarlyCheckinOffer,
    setEarlyCheckinDecision,
}

export type EarlyCheckinDecision = "confirmed" | "rejected" | null;

// Always send offset + page_size so the endpoint returns the paginated
// envelope ({ reservations, total_count }) instead of a flat array.
// Omitting uid lists every reservation owned by the user, globally ordered.
async function list(queryParams: PMSReservationsQueryParams = {}) {
    return ServiceHelper.getRequest(PMS_API_URLS.RESERVATIONS, queryParams);
}

// Offers (or withdraws) early check-in on a reservation's invitation. `uid` is
// the invitation uid, not the reservation uid. Enabling requires the
// location's early check-in toggle to be on (400, error_code 770); disabling
// is always allowed. Returns { early_checkin_offered_at: ISO | null }.
async function setEarlyCheckinOffer({ uid, enabled }: { uid: string; enabled: boolean }) {
    return ServiceHelper.postRequest(PMS_API_URLS.EARLY_CHECKIN_OFFER, {
        uid,
        enabled,
    });
}

// Answers the early check-in the guest requested. `uid` is the invitation
// uid. "confirmed" opens the guest's access from the requested hour without
// touching reservation_start (and mails the guest); "rejected" tells the
// guest it is not possible; null undoes either decision back to pending.
// Returns { early_checkin_confirmed_at: ISO | null,
//           early_checkin_rejected_at: ISO | null }.
async function setEarlyCheckinDecision({ uid, decision }: { uid: string; decision: EarlyCheckinDecision }) {
    return ServiceHelper.postRequest(PMS_API_URLS.EARLY_CHECKIN_CONFIRM, {
        uid,
        decision,
    });
}
